<template>
  <div
    data-testid="splash-page-root"
    :class="{
      onsplash: $route.name === 'EventSplash',
      notonsplash: $route.name !== 'EventSplash',
      approot: true
    }"
    :style="{
      ...$store.state.event.themeStyles,
      '--self-video-rotate-y': $store.state.mediaroom.mirrorSelf ? '180deg' : '0'
    }"
  >
    <div class="topfixed" :style="$store?.state.event.goldcastThemeStyles">
      <Toast />
      <router-view name="topfixed" />
    </div>
    <div class="bottomfixed">
      <router-view name="bottomfixed" />
    </div>
    <div class="notifications">
      <router-view name="notifications" />
    </div>
    <router-view class="page" />
    <div class="prefetchdiv"></div>
    <!-- do not remove this div, it's needed for the new tooltip implementation -->
    <div id="tooltipscontainer"></div>
    <div id="emojiPickerContainer"></div>
  </div>
</template>

<script>
import Toast from './components/core/Toast.vue';
import trackerService from './services/tracker.service';

import { getStaticAssetsUrl } from '@/constants';
import { checkAdBlocker } from '@/services/browser.service';
import('@/../tailwind/tailwind-output.css');

export default {
  name: 'App',
  components: {
    Toast
  },
  mounted() {
    this.loadGTAmericaFont();
    trackerService.init();
    checkAdBlocker();
    this.$store.dispatch('timeSync/calculateOffset');
    this.setCurrentMediaDevices();
  },
  methods: {
    loadGTAmericaFont() {
      const fontUrl = getStaticAssetsUrl('fonts/Gt%20America/GT-America-Regular.otf');
      const style = document.createElement('style');
      style.textContent = `@font-face { font-family: 'GT-America'; src: local('GT-America'), url('${fontUrl}') format('opentype'); }`;
      document.head.appendChild(style);
    },
    async setCurrentMediaDevices() {
      await this.$store.dispatch('mediaroom/initializeDevices');
      this.$store.dispatch('mediaroom/setCurrentDeviceMedia', {
        deviceType: 'camera',
        rtcDeviceArr: 'cameras'
      });
      this.$store.dispatch('mediaroom/setCurrentDeviceMedia', {
        deviceType: 'microphone',
        rtcDeviceArr: 'microphones'
      });
      this.$store.dispatch('mediaroom/setCurrentDeviceMedia', {
        deviceType: 'speaker',
        rtcDeviceArr: 'speakers'
      });
    }
  }
};
</script>

<style>
@import url(https://fonts.googleapis.com/icon?family=Material+Icons);
@import './styles/app.css';

body,
html {
  width: 100%;
  height: 100%;
  font-family: var(--theme-font-name, Custom Font), 'GT-America', sans-serif;
  margin: 0px;
}
.approot {
  width: 100%;
  height: 100%;
  flex: auto 1;
  overflow-x: hidden;
  display: block;
  font-family: var(--font-name, Custom Font), 'GT-America', sans-serif;
}
.page {
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  background: var(--theme-primary-color);
  display: flex;
  flex-direction: column;
}
.bottomfixed {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 25;
  width: 390px;
  max-height: 60vh;
  pointer-events: none;
}
.bottomfixed > * {
  pointer-events: all;
}
.notifications {
  position: fixed;
  top: 50px;
  right: 0px;
  z-index: 25;
}

.topfixed {
  top: 0px;
  /* User home top bar is set to 100 z-index */
  z-index: 101;
  position: fixed;
}

/* Drift widget styles*/
.onsplash ~ #drift-frame-controller,
.onsplash ~ #drift-frame-chat {
  bottom: 108px !important;
}
.notonsplash ~ #drift-frame-controller,
.notonsplash ~ #drift-frame-chat {
  bottom: 200vh !important;
}

@media only screen and (max-width: 600px) {
  .bottomfixed {
    width: 100vw;
  }
}
</style>
